// Maps English path segments to their Spanish equivalents so internal links
// always point at real routes (see src/App.tsx) instead of 404s.
const EN_TO_ES: Record<string, string> = {
  '/products': '/productos',
  '/grass': '/pasto',
  '/rock': '/roca',
  '/soil': '/tierra',
  '/sand': '/arena',
  '/mulch': '/mulch',
  '/services': '/servicios',
  '/services/sod-delivery': '/servicios/entrega-cesped',
  '/services/bulk-delivery': '/servicios/entrega-granel',
  '/quote': '/cotizar',
  '/contact': '/contacto',
  '/about': '/nosotros',
  '/privacy': '/privacidad',
  '/terms': '/terminos',
  '/blog': '/blog',
  '/areas': '/areas',
};

/** Returns the language-appropriate version of an English path (without language prefix). */
export const localizeSlug = (path: string, language: 'en' | 'es' | string): string =>
  language === 'es' ? EN_TO_ES[path] ?? path : path;
